// styles and images
import styles from './Footer.module.css'
import Logo from '../assets/Logo.svg'
import { Link } from "react-router-dom"
import { useAuthContext } from "../hooks/useAuthContext"

export default function Footer() {
  const DEVELOPER = 'OP14GJu-0725'
  const { user, customClaims } = useAuthContext()

  return (
    <div className={styles['main']}>
      <div className={styles['horizontal-line']}></div>
      
      <div className={styles['container']}>
        
        <div className={styles['split']}>

          <p>&nbsp;</p>
          <p onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
              className={styles['back-to-top']}>Back to Top</p>
          <p><Link to="aboutus" className={styles['link']}>About Us</Link></p>
          <p><Link to="subscriptionselection" className={styles['link']}>Plans</Link></p>
          <p>
            <a 
              href='https://firebasestorage.googleapis.com/v0/b/plus1-8ea63.appspot.com/o/documents%2FTerms%20and%20Conditions.pdf?alt=media&token=a3759aaf-a996-4342-87d0-c74bbca0d924'
              target="_blank"
              rel="noopener noreferrer nofollow">
                Terms and Conditions
            </a>
          </p>
          <p>
            <a 
              href='https://firebasestorage.googleapis.com/v0/b/plus1-8ea63.appspot.com/o/documents%2FPrivacy%20Statement.pdf?alt=media&token=1cd75e8a-8120-40c8-8b14-99b7c8e2b1b5'
              target="_blank"
              rel="noopener noreferrer nofollow">
                Privacy Statement
            </a>
          </p>
          <p><Link to="insights" className={styles['link']}>Founders' Insight</Link></p>
          {/*<p>Contact Us</p>*/}
          {/*<p>Jobs</p>*/}
          {/*<p>Credits</p>*/}
          {/*<p>FAQ</p>*/}
          {/*<p>Meet the Team</p>*/}

        </div>
        <div className={styles['split']}>

          <p>&nbsp;</p>
          <p><Link className={styles['link']} to="dashboard">Dashboard</Link></p>
          {(user && customClaims.tenantId === DEVELOPER) && <>
            <p><Link className={styles['link']} to="progress">Project</Link></p>
            <p><Link className={styles['link']} to="developer">Developer</Link></p>
          </>}
          <p><Link className={styles['link']} to="document">Add a Document</Link></p>
          <p><Link className={styles['link']} to="contactbook">Contact Book</Link></p>
          <p><Link className={styles['link']} to="pnsbook">Product List</Link></p>
        </div>
        <div className={styles['split']}>

          <p>&nbsp;</p>
          <p><Link to="feedback">We love to hear from our users</Link></p>
          <p><Link to="home">
            <img 
              src={Logo} 
              alt="Crifty Logo" 
              className={styles['logo']}
              width={150}
              height={75}
              loading="lazy"
              decoding="async"
            />
          </Link></p>
          <p>&copy; 2025</p>
        </div>
      </div>      
    </div>

  )
}